export const formatTickerToURLFriendly = (ticker: string): string => {
  if (!ticker) return '';
  return ticker.replace('/', '-');
};

export const formatTickerInURLToTicker = (ticker: string): string => {
  if (!ticker) return '';
  const cleanedTicker = ticker.replace(/[^a-zA-Z0-9-/.]/g, '');
  return formatTickerToUppercase(cleanedTicker).replace('-', '/');
};

export const formatTickerToUppercase = (ticker: string): string => {
  if (!ticker) return '';
  const areAllLettersLowercase = ticker.split('').every(letter => letter === letter.toLowerCase());
  const result = areAllLettersLowercase ? ticker.toUpperCase() : ticker;
  if (ticker.includes('-')) {
    return ticker.toUpperCase();
  }
  return result;
};
